var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "grid-view", attrs: { id: "verify-tree-grid" } },
    [
      _c(
        "div",
        { staticClass: "main-content" },
        [
          _c(
            "search-item",
            {
              attrs: {
                "config-module": "960",
                reset: true,
                "custom-sim-query-placeholder": _vm.$t(
                  "Message.QuickSearchBusinessNo"
                ),
                "auto-init": _vm.searchItemAutoInit,
                "custom-search-items": _vm.customSearchItemsAuto
              },
              on: {
                "click-more": function(value) {
                  return (_vm.isAdvancedQuery = value)
                },
                simSearchItemCallBack: _vm.toSimpleQuery,
                advSearchItemCallBack: _vm.toAdvancedQuery
              }
            },
            [
              _c(
                "div",
                { attrs: { slot: "operations" }, slot: "operations" },
                [
                  _c(
                    "el-button",
                    {
                      attrs: { no: "PrintPayment", type: "primary" },
                      on: { click: _vm.printClickHandler }
                    },
                    [_vm._v(_vm._s(_vm.$t("CargoMsg.Cargo_PrintPaymentList")))]
                  ),
                  _c(
                    "el-button",
                    {
                      directives: [
                        {
                          name: "show",
                          rawName: "v-show",
                          value: _vm.$checkPermission([
                            "button_SingleRelease_audit"
                          ]),
                          expression:
                            "$checkPermission(['button_SingleRelease_audit'])"
                        }
                      ],
                      attrs: { no: "Audit", type: "primary" },
                      on: { click: _vm.btnAuditClickHandler }
                    },
                    [_vm._v(_vm._s(_vm.$t("CargoMsg.Cargo_Audit")))]
                  ),
                  _c(
                    "el-button",
                    {
                      directives: [
                        {
                          name: "show",
                          rawName: "v-show",
                          value: _vm.$checkPermission([
                            "button_SingleRelease_audit"
                          ]),
                          expression:
                            "$checkPermission(['button_SingleRelease_audit'])"
                        }
                      ],
                      attrs: { no: "RevokeReview", type: "primary" },
                      on: { click: _vm.btnCancelAuditClickHandler }
                    },
                    [_vm._v(_vm._s(_vm.$t("CargoMsg.Cargo_RevokeReview")))]
                  ),
                  _c(
                    "el-button",
                    {
                      directives: [
                        {
                          name: "show",
                          rawName: "v-show",
                          value: _vm.$checkPermission([
                            "button_SingleRelease_detain"
                          ]),
                          expression:
                            "$checkPermission(['button_SingleRelease_detain'])"
                        }
                      ],
                      attrs: { no: "HoldDoc", type: "primary" },
                      on: { click: _vm.btnDetainClickHandler }
                    },
                    [_vm._v(_vm._s(_vm.$t("CargoMsg.Cargo_HoldDoc")))]
                  ),
                  _c(
                    "el-button",
                    {
                      directives: [
                        {
                          name: "show",
                          rawName: "v-show",
                          value: _vm.$checkPermission([
                            "button_SingleRelease_specialApproval"
                          ]),
                          expression:
                            "$checkPermission(['button_SingleRelease_specialApproval'])"
                        }
                      ],
                      attrs: { no: "specialApproval", type: "primary" },
                      on: { click: _vm.btnSpecialApprovalClickHandler }
                    },
                    [
                      _vm._v(
                        _vm._s(_vm.$t("CargoMsg.Cargo_SpecialApprovalOrder"))
                      )
                    ]
                  )
                ],
                1
              )
            ]
          ),
          _c(
            "div",
            {
              staticClass: "section grid-wrapper",
              staticStyle: { height: "40%" }
            },
            [
              _c("cargo-ag-grid", {
                staticStyle: { width: "100%", "min-height": "200px" },
                attrs: {
                  "config-module": "960002",
                  "grid-options": _vm.audit.gridOptions,
                  "side-bar": {
                    toolPanels: ["columns", "filter"],
                    visible: false
                  },
                  "column-defs": _vm.columnDefs,
                  "row-data": _vm.audit.rowData,
                  "grid-params": _vm.audit.gridParams
                },
                on: {
                  "update:gridParams": function($event) {
                    return _vm.$set(_vm.audit, "gridParams", $event)
                  },
                  "update:grid-params": function($event) {
                    return _vm.$set(_vm.audit, "gridParams", $event)
                  },
                  gridReady: _vm.onGridReady
                }
              })
            ],
            1
          ),
          _c(
            "div",
            { staticClass: "pagination-wrapper" },
            [
              _c("cargo-pagination", {
                attrs: {
                  total: _vm.total,
                  "page-count": _vm.pageCount,
                  "config-module": "960001",
                  page: _vm.filter.pageNum,
                  limit: _vm.filter.pageSize
                },
                on: {
                  "update:page": function($event) {
                    return _vm.$set(_vm.filter, "pageNum", $event)
                  },
                  "update:limit": function($event) {
                    return _vm.$set(_vm.filter, "pageSize", $event)
                  },
                  pagination: _vm.toQueryByPage
                }
              })
            ],
            1
          ),
          _c(
            "div",
            {
              staticClass: "section grid-wrapper",
              staticStyle: { height: "30%" }
            },
            [
              _c("cargo-ag-grid", {
                staticStyle: { width: "100%", height: "100%" },
                attrs: {
                  "config-module": "960003",
                  "grid-options": _vm.selectShow.gridOptions,
                  "column-defs": _vm.columnDef,
                  "row-data": _vm.selectShow.rowData,
                  "grid-params": _vm.selectShow.gridParams
                },
                on: {
                  "update:gridParams": function($event) {
                    return _vm.$set(_vm.selectShow, "gridParams", $event)
                  },
                  "update:grid-params": function($event) {
                    return _vm.$set(_vm.selectShow, "gridParams", $event)
                  },
                  gridReady: _vm.onSelectShowGridReady
                }
              })
            ],
            1
          )
        ],
        1
      ),
      _c("cargo-template-selector-dialog", {
        attrs: {
          visible: _vm.templateSelectorDialog.visible,
          ctx: _vm.templateSelectorDialog.cxt,
          category: _vm.templateSelectorDialog.category,
          data: _vm.templateSelectorDialog.data
        },
        on: {
          "update:visible": function($event) {
            return _vm.$set(_vm.templateSelectorDialog, "visible", $event)
          }
        }
      }),
      _c("withhold-reason-window", {
        attrs: {
          visible: _vm.withOldWindow.visible,
          list: _vm.withOldWindow.list
        },
        on: {
          "update:visible": function($event) {
            return _vm.$set(_vm.withOldWindow, "visible", $event)
          },
          saveWithholdReasonHandler: _vm.saveWithholdReasonHandler
        }
      }),
      _vm.releaseRuleResultWindow.visible
        ? _c("release-rule-result-window", {
            attrs: {
              visible: _vm.releaseRuleResultWindow.visible,
              "release-rules": _vm.releaseRuleResultWindow.releaseRules
            },
            on: {
              "update:visible": function($event) {
                return _vm.$set(_vm.releaseRuleResultWindow, "visible", $event)
              },
              close: function($event) {
                _vm.releaseRuleResultWindow.visible = false
              }
            }
          })
        : _vm._e(),
      _vm.batchCheckingWindow.visible
        ? _c("batch-checking-window", {
            ref: "batchCheckingWindow",
            attrs: {
              visible: _vm.batchCheckingWindow.visible,
              "allow-partial-check-pass":
                _vm.batchCheckingWindow.allowPartialCheckPass,
              lob: _vm.batchCheckingWindow.lob,
              jobs: _vm.batchCheckingWindow.jobs,
              "check-node": _vm.batchCheckingWindow.checkNode,
              "call-back": _vm.batchCheckingWindow.callBack,
              "call-back2": _vm.batchCheckingWindow.callBack2
            },
            on: {
              "update:visible": function($event) {
                return _vm.$set(_vm.batchCheckingWindow, "visible", $event)
              }
            }
          })
        : _vm._e()
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }